import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";

export const Panel = (props) => {
  const {
    header,
    children,
    eventKey = "1",
    defaultActiveKey = "1",
    activeKey,
    padBottom = true,
    hasErrors = false,
    id,
    ...rest
  } = props;

  const [internalActiveKey, setInternalActiveKey] = useState(
    activeKey || defaultActiveKey,
  );

  useEffect(() => {
    if (!activeKey) return;
    setInternalActiveKey(activeKey);
  }, [activeKey]);

  const toggleInternalActiveKey = () => {
    setInternalActiveKey((currKey) =>
      currKey === eventKey ? "definitely_not_the_event_key" : eventKey,
    );
  };

  const headerClassName = hasErrors ? "panelError" : "";

  return (
    <Accordion
      activeKey={internalActiveKey}
      className={padBottom ? "padBottom" : ""}
      {...rest}
    >
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header
          onClick={toggleInternalActiveKey}
          className={headerClassName}
          id={id}
        >
          {header}
        </Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
